export default "__VITE_ASSET__EMcedm7F__"